import { toPoints } from './scoreScale';

export function formatValue(value, format) {
  if (value === null || value === undefined || value === '') return '—';
  if (value === 'CEP') return 'CEP';
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return String(value);
  if (format === 'percent') return `${(numeric * 100).toFixed(1)}%`;
  if (format === 'integer') return Math.round(numeric).toLocaleString();
  if (format === 'oneDecimal') return numeric.toFixed(1);
  return numeric.toFixed(2);
}

export function formatScore(score) {
  const points = toPoints(score);
  if (points === null) return '—';
  return points.toFixed(1);
}

export function formatPercent(value, digits = 0) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '—';
  return `${(numeric * 100).toFixed(digits)}%`;
}
